import { DEMAND_CALLOFF_EXTERNAL } from '~/routes/(custom)/external/call-offs.$callOffId';
import { SUPPLIER_ACTIVATION_EXTERNAL } from '~/routes/(custom)/external/data-exchange-activation.$requestId';
import { UNSUBSCRIBE_EXTERNAL } from '~/routes/(custom)/external/unsubscribe';
import { DASHBOARD } from '~/routes/(main)';
import { ACCOUNT } from '~/routes/(main)/account';
import { ANALYTICS } from '~/routes/(main)/analytics';
import { ANALYTICS_DELIVERIES } from '~/routes/(main)/analytics/deliveries';
import { ANALYTICS_ESG } from '~/routes/(main)/analytics/esg';
import { ANALYTICS_USAGE } from '~/routes/(main)/analytics/usage';
import { DELIVERIES } from '~/routes/(main)/deliveries/all';
import { DELIVERIES_V2 } from '~/routes/(main)/deliveries/all-v2';
import { DELIVERY_DATA_QUALITY } from '~/routes/(main)/deliveries/all/$deliveryId/data-quality';
import { DELIVERY } from '~/routes/(main)/deliveries/all/$deliveryId/route';
import { CREATE_DELIVERY_NOTE } from '~/routes/(main)/deliveries/all/create-delivery-note';
import { CREATE_SERVICE_NOTE } from '~/routes/(main)/deliveries/all/create-service-note';
import { DELIVERY_RECENT_CHANGES } from '~/routes/(main)/deliveries/recent-changes';
import { DELIVERY_SCANS } from '~/routes/(main)/deliveries/scans';
import { DEMAND_CALLOFFS } from '~/routes/(main)/demand/call-offs';
import { DEMAND_CALLOFF } from '~/routes/(main)/demand/call-offs/$callOffId';
import { DEMAND_CALLOFF_EDIT } from '~/routes/(main)/demand/call-offs/$callOffId/edit';
import { DEMAND_CALLOFFS_CALENDAR } from '~/routes/(main)/demand/call-offs/calendar';
import { DEMAND_CALLOFF_CREATE } from '~/routes/(main)/demand/call-offs/create';
import { DEMAND_CONTRACTS } from '~/routes/(main)/demand/contracts';
import { DEMAND_CONTRACT } from '~/routes/(main)/demand/contracts/$contractId';
import { DEMAND_CONTRACT_EDIT } from '~/routes/(main)/demand/contracts/$contractId/edit';
import { DEMAND_CONTRACT_CREATE } from '~/routes/(main)/demand/contracts/create';
import { INCOMING_INVOICES } from '~/routes/(main)/invoices/incoming';
import { INCOMING_INVOICE } from '~/routes/(main)/invoices/incoming/$invoiceId/route';
import { OUTGOING_INVOICES } from '~/routes/(main)/invoices/outgoing';
import { LEGAL } from '~/routes/(main)/legal';
import { RELEASE_NOTES } from '~/routes/(main)/release-notes';
import * as SETTINGS from '~/routes/(main)/settings/-index';
import { SUPPLIERS } from '~/routes/(main)/suppliers';
import { SUPPLIER_DETAIL } from '~/routes/(main)/suppliers/$supplierId';
import { SUPPLIER_EDIT } from '~/routes/(main)/suppliers/$supplierId/edit';
import { SUPPORT } from '~/routes/(main)/support';
import { SUPPORT_FAQ } from '~/routes/(main)/support/faq';

export const ROUTES = {
  ACCOUNT,
  ANALYTICS,
  ANALYTICS_DELIVERIES,
  ANALYTICS_ESG,
  ANALYTICS_USAGE,
  CREATE_DELIVERY_NOTE,
  CREATE_SERVICE_NOTE,
  DASHBOARD,
  DELIVERIES,
  DELIVERIES_V2,
  DELIVERY,
  DELIVERY_DATA_QUALITY,
  DELIVERY_RECENT_CHANGES,
  DELIVERY_SCANS,
  DEMAND_CALLOFF,
  DEMAND_CALLOFF_CREATE,
  DEMAND_CALLOFF_EDIT,
  DEMAND_CALLOFF_EXTERNAL,
  DEMAND_CALLOFFS,
  DEMAND_CALLOFFS_CALENDAR,
  DEMAND_CONTRACT,
  DEMAND_CONTRACT_CREATE,
  DEMAND_CONTRACT_EDIT,
  DEMAND_CONTRACTS,
  INCOMING_INVOICE,
  INCOMING_INVOICES,
  LEGAL,
  OUTGOING_INVOICES,
  RELEASE_NOTES,
  SUPPLIER_ACTIVATION_EXTERNAL,
  SUPPLIER_DETAIL,
  SUPPLIER_EDIT,
  SUPPLIERS,
  SUPPORT,
  SUPPORT_FAQ,
  UNSUBSCRIBE_EXTERNAL,
  ...SETTINGS,
};

/**
 * Routes that can be accessed without authentication (public routes).
 * These routes bypass the OIDC auto-signin and render directly.
 *
 * Used in:
 * - App.tsx: to disable autoSignIn for AuthProvider
 * - AppInitializer.tsx: to skip user data loading
 */
const PUBLIC_ROUTE_PREFIXES = [
  '/external/call-offs/',
  '/external/data-exchange-activation/',
  '/external/unsubscribe',
] as const;

/**
 * Check if a pathname matches a public route prefix.
 */
export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTE_PREFIXES.some((prefix) => pathname.startsWith(prefix));
}

/**
 * Gets the complete route export object for a given route key.
 *
 * @param route - The route key from the ROUTES object
 * @returns The complete RouteExport object containing the Route instance and metadata
 */
export const getRoute = (route: keyof typeof ROUTES) => {
  return ROUTES[route];
};
